<template>
	<div class="app-container " :class="classCustom">
		{{classCustom}}
		<router-view />
	</div>
</template>
<script setup lang="ts">
	import { onMounted } from 'vue'

	const classCustom = ref(null)
	const router = useRouter()
	const path = router.currentRoute.value.path

	// 20260602 新增模块详情/项目介绍 小尺寸时直接截断
	function getClassCustom() {
		if (path === '/moduleAndRequirementCreateAndEditAndDetails' || path === '/projectCreateAndIntroduceAndEdit') {
			classCustom.value = 'overflowH'
		}
	}

	onMounted(() => {
		getClassCustom()
	})

	const href = window.location.href
	// 20260324 新增根据当前访问地址 增加动态标题
	if (href.includes('demo.')) {
		document.title = '云联智办 - 云联办(体验)'
	}
</script>
<style lang="scss">
	@import "@/styles/handle.scss";

	html,
	body {
		padding: 0;
		margin: 0;
		// 20260105注释
		// position: relative;
	}

	// ::-webkit-scrollbar {
	// 	display: none;
	// }

	.recordNumberBlo {
		width: 100%;
		text-align: center;
		padding: 12px 0 8px 0;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
		column-gap: 8px;
		@include color('record_number_color');

		>div {
			display: flex;
			column-gap: 8px;
			margin-bottom: 4px;
		}

		a {
			text-decoration: unset;
			white-space: nowrap;
		}

		a:link {
			@include color('record_number_color');
		}

		a:visited {
			@include color('record_number_color');
		}

		a:hover {
			@include color('record_number_color');
		}

		a:active {
			@include color('record_number_color');
		}

		span {
			white-space: nowrap;
		}
	}

	@media screen and (max-width: 500px) {

		.recordNumberBlo {
			padding-bottom: 4px;

			>div {
				width: 100%;
				justify-content: center;
				margin-bottom: 8px !important;
			}

			.line {
				display: none;
			}
		}
	}
</style>